<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                </ion-buttons>
                <ion-title>Charging Station List </ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <CPOChargingStations />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import CPOChargingStations from "@/components/corporate/CPOChargingStations.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'cpoChargingStations',
    components: {
        CPOChargingStations, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        }
    }
})
</script>